<template>
  <div class="min-h-screen bg-white w-full">
    <Loader :show="isLoading" />
    <Header />
    <router-view v-slot="{ Component }">
      <component :is="Component" @vue:mounted="onComponentMounted" />
    </router-view>
    <Footer v-if="!isLoading" />
    <StickyMobileCTA />
    <LegalModal
      :is-open="modalOpen"
      :type="modalType"
      @close="closeModal"
    />
    <DemoRequestModal 
      v-if="isDemoModalOpen" 
      @close="closeDemoModal" 
    />
  </div>
</template>

<script setup lang="ts">
import { ref, provide } from 'vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import StickyMobileCTA from './components/StickyMobileCTA.vue'
import LegalModal from './components/modals/LegalModal.vue'
import DemoRequestModal from './components/modals/DemoRequestModal.vue'
import { useRouter } from 'vue-router'
import Loader from './components/loader/Loader.vue'
import { trackFacebookCustomEvent } from './utils/facebook-pixel'

const isLoading = ref(true)

const onComponentMounted = () => {
  isLoading.value = false
}

// Legal Modal State
const modalOpen = ref(false)
const modalType = ref<'privacy' | 'terms'>('privacy')

const openModal = (type: 'privacy' | 'terms') => {
  modalType.value = type
  modalOpen.value = true
}

const closeModal = () => {
  modalOpen.value = false
}

provide('openModal', openModal)

// Demo Request Modal State
const isDemoModalOpen = ref(false)

const openDemoModal = () => {
  trackFacebookCustomEvent('ClickScheduleDemo');
  isDemoModalOpen.value = true
}

const closeDemoModal = () => {
  isDemoModalOpen.value = false
}

provide('openDemoModal', openDemoModal)

// Captura o parâmetro "ref" na URL ao carregar a página
const params = new URLSearchParams(window.location.search)
const refParam = params.get('ref')

if (refParam) {
  localStorage.setItem('_ref', refParam)
} else {
  localStorage.removeItem('_ref')
}

const router = useRouter()

router.beforeEach(() => {
  isLoading.value = true
})

router.afterEach((to) => {
  setTimeout(() => {
    if (to.hash) {
      const el = document.querySelector(to.hash)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }
    isLoading.value = false
  }, 800)
})

</script>
